export const environment = {
  webBaseUrl: 'https://baba.datastep.solutions',
  apiBaseUrl: 'https://baba.datastep.solutions',
  paypalBaseUrl: 'https://api-m.sandbox.paypal.com',
  simplepayBaseUrl: '/api/simplepay',
  pilotMode: false
}
